import { apolloClient } from '../../lib'
import { localeToMarketCode } from '../../utils'
import { GET_BANNERS_QUERY } from '../queries/getBannersQuery'
import {
  Banners_Filter,
  Banners_Translations_Filter,
  GetBannersQuery,
  GetBannersQueryVariables,
} from '../__generated__/types'

export const fetchBanners = async (
  locale: string,
  slug: string,
): Promise<GetBannersQuery['banners']> => {
  const pageFilter: Banners_Filter = {
    pages: {
      pages_id: {
        slug: {
          _eq: slug,
        },
      },
    },
  }
  const marketsFilter: Banners_Filter = {
    markets: {
      markets_code: {
        code: {
          _eq: localeToMarketCode(locale),
        },
      },
    },
  }
  const statusFilter: Banners_Filter = {
    status: {
      _eq: 'published',
    },
  }
  const translationsFilter: Banners_Translations_Filter = { languages_code: { _eq: locale } }
  const {
    data: { banners },
  } = await apolloClient.query<GetBannersQuery, GetBannersQueryVariables>({
    query: GET_BANNERS_QUERY,
    variables: {
      filter: { ...pageFilter, ...marketsFilter, ...statusFilter },
      translations_filter: translationsFilter,
    },
  })
  return banners
}
